import TopService from '@/common/api/top'
import {
  GET_TOP,
  TOP_FONT_SCALE
} from './actions'
import {
  FETCH_LOGIN_USER,
  FETCH_SITE_INFO,
  CHANGE_TOP_FONT_SCALE,
  FETCH_MAINTENANCE
} from './mutations'

const state = {
  loginUser: {},
  siteInfo: {},
  fontScale: ((sessionStorage.getItem('isChangeFontScale') || 'false') === 'true'),
  maintenance: {
    status: 'off',
    body: ''
  }
}

const getters = {
  loginUser (state) {
    return state.loginUser
  },
  siteInfo (state) {
    return state.siteInfo
  },
  fontScale (state) {
    return state.fontScale
  },
  maintenance (state) {
    return state.maintenance
  }
}

const actions = {
  [GET_TOP] (context, params = {}) {
    return new Promise((resolve, reject) => {
      TopService.get(params)
        .then(({ data }) => {
          context.commit(FETCH_LOGIN_USER, data)
          context.commit(FETCH_SITE_INFO, data)
          context.commit(FETCH_MAINTENANCE, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_LOGIN_USER, null)
          reject(error)
        })
    })
  },
  [TOP_FONT_SCALE] (context, isChange = false) {
    context.commit(CHANGE_TOP_FONT_SCALE, isChange)
  }
}

const mutations = {
  [FETCH_LOGIN_USER] (state, data) {
    if (data == null) {
      if (typeof state.loginUser !== 'object') {
        state.loginUser = {}
      }
      state.loginUser = {
        user: null,
        point: null,
        messageUnreadCount: 0
      }
    } else {
      state.loginUser = {
        user: data.user,
        point: data.point,
        messageUnreadCount: data.message_unread_count
      }
    }
  },
  [FETCH_SITE_INFO] (state, data) {
    state.siteInfo = {
      title: data.title,
      mailDomain: data.mail_domain,
      telephone: data.telephone,
      inquiryMail: data.inquiry_mail,
      page: data.page
    }
  },
  [FETCH_MAINTENANCE] (state, data) {
    if (data.maintenance !== undefined) {
      state.maintenance = data.maintenance
    } else {
      state.maintenance = {
        status: 'off',
        body: ''
      }
    }
  },
  [CHANGE_TOP_FONT_SCALE] (state, data) {
    state.fontScale = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
